import { useState } from "react"
import EditForms from "./EditForms"
import FormRequest from "./FormRequest"
import { Layout, Menu } from 'antd'

import {
    EditOutlined,
    FolderOpenOutlined
  } from '@ant-design/icons'

import "./Forms.css"


const Forms = () => {
    const { Sider } = Layout
    const [selectedKey, setSelectedKey] = useState("1")

    const getItem = (label, key, icon, children) => {
        return {
          key,
          icon,
          children,
          label,
        }
    }

    const items = [
        getItem('Edit Forms', '1', <EditOutlined />),
        getItem('Request Forms', '2', <FolderOpenOutlined />)
    ]

    return(
        <Layout style={{minHeight: '100vh'}}>
            <Sider
                width={280}
                theme="light"
                breakpoint="lg"
                collapsedWidth="0"
                onBreakpoint={(broken) => {
                console.log(broken);
                }}
                onCollapse={(collapsed, type) => {
                console.log(collapsed, type);
                }}
                onChange={(e) => console.log(e)}
                style={{borderRight: '1px solid lightgray'}}
            >
                <div className="demo-logo-vertical" style={{padding: '20px',}}/>
                <Menu theme="light" mode="inline" defaultSelectedKeys={[selectedKey]} items={items} onClick={(e) => setSelectedKey(e.key)} />
            </Sider>
            <div className="forms-main">
                <div className="forms-container">
                    {selectedKey === "1" && <EditForms />}
                    {selectedKey === "2" && <FormRequest />}
                </div>
            </div>
        </Layout>
    )
}

export default Forms